var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c(
        "Subheader",
        {
          attrs: { title: "Standards", search: "Standards" },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: { small: "", color: "add" },
              on: {
                click: function ($event) {
                  return _vm.clickAddStandard()
                },
              },
            },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
              _vm._v(_vm._s(_vm.$t("Button.Add")) + "\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.originalData.Standards,
              "hide-actions": "",
              search: _vm.search,
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function (props) {
                  return [
                    _c(
                      "td",
                      { staticClass: "text-xs-left", attrs: { width: "15%" } },
                      [_vm._v(_vm._s(props.item.AnalyteNameInGuideline))]
                    ),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "text-xs-left",
                      attrs: { width: "15%" },
                      domProps: {
                        innerHTML: _vm._s(_vm.getGuidelineValue(props.item)),
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left", attrs: { width: "7%" } },
                      [_vm._v(_vm._s(props.item.ValueType))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left", attrs: { width: "7%" } },
                      [_vm._v(_vm._s(props.item.Unit))]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-left", attrs: { width: "7%" } },
                      [_vm._v(_vm._s(props.item.ComparisonOperation))]
                    ),
                    _vm._v(" "),
                    _vm.IsHtml(props.item.ReferenceSource)
                      ? [
                          _vm.linkTo(props.item.ReferenceSource)
                            ? _c("td", { staticClass: "text-xs-left" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.linkTo(
                                        props.item.ReferenceSource
                                      ),
                                      target: "_blank",
                                    },
                                  },
                                  [_vm._v(_vm._s(props.item.ReferenceSource))]
                                ),
                              ])
                            : _c("td", {
                                staticClass: "text-xs-left",
                                domProps: {
                                  innerHTML: _vm._s(props.item.ReferenceSource),
                                },
                              }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.IsHtml(props.item.ReferenceSource)
                      ? [
                          _c("td", {
                            staticClass: "text-xs-left",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.linkExtract(props.item.ReferenceSource)
                              ),
                            },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(
                        _vm._s(
                          props.item.LastModifiedDateTime != null
                            ? _vm.formatDate(
                                props.item.LastModifiedDateTime,
                                _vm.prettyDateTimeFormat
                              )
                            : ""
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.Notes)),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.LastModifiedBy)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-right", attrs: { width: "18%" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { small: "", dark: "", color: "warning" },
                            on: {
                              click: function ($event) {
                                return _vm.clickEditStandard(props.item)
                              },
                            },
                          },
                          [
                            _c("v-icon", { staticClass: "mr-1" }, [
                              _vm._v("edit"),
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("Button.Edit")) +
                                "\n          "
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { small: "", dark: "", color: "delete" },
                            on: {
                              click: function ($event) {
                                return _vm.clickDeleteStandard(props.item)
                              },
                            },
                          },
                          [
                            _c("v-icon", { staticClass: "mr-1" }, [
                              _vm._v("delete_forever"),
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("Button.Remove")) +
                                "\n          "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("GuidelinesDetailStandards.titleMsg", {
                          msg: _vm.titleInfo,
                        })
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form",
                  staticStyle: { width: "100%" },
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: { row: "", wrap: "", "pl-5": "", "pr-5": "" },
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Analyte Name",
                                  rules: _vm.AnalyteNameRule,
                                },
                                model: {
                                  value:
                                    _vm.standardData.AnalyteNameInGuideline,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.standardData,
                                      "AnalyteNameInGuideline",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "standardData.AnalyteNameInGuideline",
                                },
                              }),
                              _vm._v(" "),
                              _vm.standardData.ValueType !=
                                _vm.AmmoniaLookupTable &&
                              _vm.standardData.ValueType != _vm.LookupTable
                                ? _c("HighlightTextField", {
                                    attrs: {
                                      label: "Guideline Value",
                                      rules: _vm.valueRule,
                                      dialog: _vm.dialog,
                                      useMenu: true,
                                    },
                                    on: { formulaList: _vm.getFormulaList },
                                    model: {
                                      value: _vm.standardData.StandardValue,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.standardData,
                                          "StandardValue",
                                          $$v
                                        )
                                      },
                                      expression: "standardData.StandardValue",
                                    },
                                  })
                                : _c("div", [
                                    _c("div", [
                                      _c("span", { staticClass: "caption" }, [
                                        _vm._v("Guideline Value"),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-alert",
                                          {
                                            attrs: {
                                              value: true,
                                              type: "warning",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "Editing Lookup table guideline type is not supported yet. Please contact the system administrator is changed to the lookup table guideline is needed."
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", "pr-3": "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Unit",
                                  items: _vm.allUnits,
                                  "item-text": "Name",
                                  "item-value": "Name",
                                  rules: _vm.unitRule,
                                },
                                model: {
                                  value: _vm.standardData.Unit,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.standardData, "Unit", $$v)
                                  },
                                  expression: "standardData.Unit",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", "pl-2": "", "pr-2": "" } },
                            [
                              _vm.standardData.ValueType ==
                              _vm.AmmoniaLookupTable
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: "ValueType",
                                      value: _vm.AmmoniaLookupTable,
                                      disabled: "",
                                    },
                                  })
                                : _vm.standardData.ValueType == _vm.LookupTable
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: "ValueType",
                                      value: _vm.LookupTable,
                                      disabled: "",
                                    },
                                  })
                                : _c("v-autocomplete", {
                                    attrs: {
                                      label: "ValueType",
                                      items: _vm.valueTypelist,
                                      rules: _vm.valueTypeRule,
                                    },
                                    model: {
                                      value: _vm.standardData.ValueType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.standardData,
                                          "ValueType",
                                          $$v
                                        )
                                      },
                                      expression: "standardData.ValueType",
                                    },
                                  }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", "pl-3": "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Comparison Operation",
                                  items: _vm.comparisonOperationlist,
                                  rules: _vm.comparisonOperationRule,
                                },
                                model: {
                                  value: _vm.standardData.ComparisonOperation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.standardData,
                                      "ComparisonOperation",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "standardData.ComparisonOperation",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  "auto-grow": "",
                                  label: "Reference Source",
                                  rows: "1",
                                  rules: _vm.referenceRule,
                                },
                                model: {
                                  value: _vm.standardData.ReferenceSource,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.standardData,
                                      "ReferenceSource",
                                      $$v
                                    )
                                  },
                                  expression: "standardData.ReferenceSource",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  "auto-grow": "",
                                  label: "Notes",
                                  rows: "1",
                                },
                                model: {
                                  value: _vm.standardData.Notes,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.standardData, "Notes", $$v)
                                  },
                                  expression: "standardData.Notes",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  "auto-grow": "",
                                  label: "Last Modified By",
                                  rows: "1",
                                },
                                model: {
                                  value: _vm.standardData.LastModifiedBy,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.standardData,
                                      "LastModifiedBy",
                                      $$v
                                    )
                                  },
                                  expression: "standardData.LastModifiedBy",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("TestFormula", {
                        attrs: {
                          Formula: _vm.standardData.StandardValue,
                          dialog: _vm.dialog,
                          ValueType: _vm.standardData.ValueType,
                        },
                      }),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.checkData()
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("done")]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Save")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { outline: "", color: "secondary" },
                          on: {
                            click: function ($event) {
                              return _vm.closeDialog()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800" },
          model: {
            value: _vm.comfirmDialog,
            callback: function ($$v) {
              _vm.comfirmDialog = $$v
            },
            expression: "comfirmDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("GuidelinesDetailStandards.confirmTitleMsg", {
                            msg1: _vm.deleteStandard.AnalyteNameInGuideline,
                            msg2: _vm.name,
                          })
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.comfirmDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  _vm._s(_vm.$t("GuidelinesDetailStandards.confirmTextMsg"))
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.deleteGuidelineStandard()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("delete_forever"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("Button.Remove")) + "\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outline: "", color: "secondary" },
                      nativeOn: {
                        click: function ($event) {
                          _vm.comfirmDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("app-modal", {
        attrs: { persistent: "", "max-width": "600" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t(
                        "GuidelinesDetailStandards.standardValueSaveConfirmTitleMsg",
                        { name: _vm.noUnitCofactorString }
                      )
                    ) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t(
                        "GuidelinesDetailStandards.standardValueSaveConfirmTextMsg",
                        { name: _vm.noUnitCofactorString }
                      )
                    ) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success" },
                    nativeOn: {
                      click: function ($event) {
                        _vm.saveComfirmDialog = false
                        _vm.saveGuidelineStandard()
                      },
                    },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { outline: "", color: "secondary" },
                    nativeOn: {
                      click: function ($event) {
                        _vm.saveComfirmDialog = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.saveComfirmDialog,
          callback: function ($$v) {
            _vm.saveComfirmDialog = $$v
          },
          expression: "saveComfirmDialog",
        },
      }),
      _vm._v(" "),
      _c("AppConfirmationModal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("GuidelinesDetailStandards.differentTitle", {
                        link: _vm.pluralize(
                          "link",
                          _vm.differentTenants.length
                        ),
                      })
                    ) +
                    "\n    "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-alert",
                  {
                    attrs: { type: "warning", outline: "" },
                    model: {
                      value: _vm.differentUnitGroupModel,
                      callback: function ($$v) {
                        _vm.differentUnitGroupModel = $$v
                      },
                      expression: "differentUnitGroupModel",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("GuidelinesDetailStandards.differentMsg", {
                            msg: _vm.differentTenantsName,
                            tenant: _vm.pluralize(
                              "tenant",
                              _vm.differentTenants.length
                            ),
                          })
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "success", dark: "" },
                    on: { click: _vm.saveGuidelineStandard },
                  },
                  [
                    _c("v-icon", { staticClass: "mr-1" }, [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Update_Anyway")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    on: {
                      click: function ($event) {
                        _vm.differentUnitGroupModel = false
                        _vm.dialog = false
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.differentUnitGroupModel,
          callback: function ($$v) {
            _vm.differentUnitGroupModel = $$v
          },
          expression: "differentUnitGroupModel",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "center" },
              attrs: {
                color: _vm.snackColor,
                timeout: null,
                top: "",
                "auto-height": "",
              },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }